import { APIClient } from '@frontend/api-utils';
import { fileDownload } from '@frontend/common';

export class ProductImportClient extends APIClient {
    public static readonly endpoint = '/import-api/v1';

    //Import

    public static async fetchProductTemplateFile(accountId: string): Promise<void> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/products-template-xlsx-file`);
        const file = await this.handleBlobResponse(response);
        const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1];
        fileDownload(file, fileName);
    }

    public static async importProducts(accountId: string, catalogId: string, spotId: string, importLogId: string): Promise<void> {
        const response = await this.fetch(
            `${this.endpoint}/accounts/${accountId}/catalogs/${catalogId}/spots/${spotId}/import-logs/${importLogId}/import-products`
        );
        return await this.handleVoidResponse(response);
    }

    // Export

    public static async exportAccountProducts(accountId: string): Promise<void> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/export-products`);
        const file = await this.handleBlobResponse(response);
        const fileName = response.headers.get('Content-Disposition')?.split('filename=')[1];
        fileDownload(file, fileName);
    }
}
